import React from 'react';
import styled from 'styled-components';
import { InfoCircleIcon } from '../../assets';

function ToolTip({message, icon}) {
    return (
        <TooltipWrapper>
            <GFeildsInfo src={icon || InfoCircleIcon} alt="icon" />
            <TooltipText className="tooltip">
            {message}
            </TooltipText>
        </TooltipWrapper>
    );
}

export default ToolTip;



const GFeildsInfo = styled.img`
  width: 18px;
  height: 18px;
  object-fit: cover;
`;

const TooltipWrapper = styled.div`
  position: relative;
  display: inline-block;

  &:hover .tooltip {
    visibility: visible;
    opacity: 1;
  }
`;

const TooltipText = styled.div`
  visibility: hidden;
  color: #000000;
  font-weight: 500;
  font-size: 12px;
  text-align: start;
  padding: 8px 16px;
  border-radius: 4px;
  position: absolute;
  z-index: 99999;
  top: 125%; /* Show below the icon */
  left: 50%;
  transform: translateX(-50%);
  opacity: 0;
  transition: opacity 0.3s;
  max-width: 280px;
  width: 280px;
  backdrop-filter: blur(20px);
  background: var(--backgrounds-primary, #ffffff);
  font-family: "Montserrat", sans-serif;
  &::after {
    content: "";
    position: absolute;
    bottom: 100%; /* Top of the tooltip box */
    left: 50%;
    margin-left: -6px;
    border-width: 6px;
    border-style: solid;
    border-color: transparent transparent var(--backgrounds-primary, #ffffff)
      transparent;
  }
`;
